module.exports = __webpack_public_path__ + "media/images/icons/right-arrow-double-b7d0df882e23770069ca5e0b42a5210f.svg";